import { Outlet } from "react-router-dom";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";

const MainLayout = ({loginModalOpen, closeLoginModal, openLoginModal}) => {
    return (
        <div className="d-flex flex-column min-vh-100">
            <Navbar
                loginModalOpen={loginModalOpen}
                closeLoginModal={closeLoginModal}
                openLoginModal={openLoginModal}
            />

            <main className="flex-grow-1">
                <Outlet />
            </main>

            <Footer />
        </div>
    );
};

export default MainLayout;